<template>
  <a class="link-button-style" @click="clickLinkButton">{{ buttonName }}</a>
</template>

<script>
export default {
  name: "link-button",
  props: {
    buttonName: String,
  },
  methods: {
    clickLinkButton() {
      this.$emit("clickLinkButton");
    },
  },
};
</script>

<style>
.link-button-style {
  margin-left: 20px;
  color: #ff5421;
  cursor: pointer;
}

.link-button-style:hover {
  margin-left: 20px;
  color: #fc6b3f;
  cursor: pointer;
}
</style>